import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ddc6fe66")

_pushScopeId("data-v-ddc6fe66")
const _hoisted_1 = { class: "health-service" }
const _hoisted_2 = {
  key: 0,
  class: "content"
}
const _hoisted_3 = { class: "card" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "success" }, [
  /*#__PURE__*/_createVNode("svg", { viewBox: "0 0 15 15" }, [
    /*#__PURE__*/_createVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M0 7.5a7.5 7.5 0 1 1 15 0a7.5 7.5 0 0 1-15 0Zm7.072 3.21l4.318-5.398l-.78-.624l-3.682 4.601L4.32 7.116l-.64.768l3.392 2.827Z",
      "clip-rule": "evenodd"
    })
  ])
], -1)
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "image-card" }
const _hoisted_7 = {
  key: 1,
  class: "content"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "card" }, [
  /*#__PURE__*/_createVNode("div", { class: "text" }, "请扫描小程序二维码进入预约页面，详细预约流程和注意事项如下。")
], -1)
const _hoisted_9 = { class: "image-card" }
_popScopeId()

import { useRoute, useRouter } from "vue-router"
import { ref } from "vue";
import apiUtil from "@/apiUtil";
import { Notify } from 'vant'
import dayjs from 'dayjs'

export default _defineComponent({
  expose: [],
  setup(__props) {

const route = useRoute()
const thirdOrderNo = ref(route.query.thirdOrderNo)
const useId = ref(route.query.useId)
const showStatus = ref(null)

const step = ref()
const show = ref(false)
const createTime = ref('')
const init = async () => {
  try {
    if (thirdOrderNo.value) {
      const res = await apiUtil.apiUtilGet('/PKECUser/ycgj/getPersonInformation', { thirdOrderNo: thirdOrderNo.value })
      if (res.data) {
        const data = {
          thirdOrderNo: thirdOrderNo.value,
          name: res.data.name,
          idNumber: res.data.idNumber,
          phone: res.data.phone,
          marriageType: res.data.marriage,
          contactName: res.data.contactName,
          contactPhone: res.data.contactPhone
        }
        const product = await apiUtil.apiUtilPost('/PKECUser/ycgj/createOrderItem', data)
        if (product.data) {
          createTime.value = product.data.createTime ? dayjs(product.data.createTime).format('YYYY年MM月DD日HH时mm分') : ''
          step.value = product.data.type
          show.value = true
        }
      }
    }
  } catch (error) {
    Notify({ type: 'danger', message: error.message });
  }
}
init()

return (_ctx: any,_cache: any) => {
  const _component_van_image = _resolveComponent("van-image")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (step.value === 0)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode("div", _hoisted_5, "您已于" + _toDisplayString(createTime.value) + "提交使用人信息，请于1个工作日后进入此页面扫码完成预约。", 1)
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_van_image, {
              class: "image",
              src: require('@/assets/image/bg.png')
            }, null, 8, ["src"])
          ])
        ]))
      : _createCommentVNode("", true),
    (step.value === 1)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          _hoisted_8,
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_van_image, {
              class: "image",
              src: require('@/assets/image/bg.png')
            }, null, 8, ["src"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})